import { gql } from "@apollo/client";

export const BULK_CREATE_EQUIPMENT_REQUEST_ITEMS_FOR_REQUEST = gql`
    mutation bulkCreateEquipmentRequestItemsForRequest($items: [BulkCreateEquipmentRequestItemInputType]!, $requestId: Int!) {
        bulkCreateEquipmentRequestItemsForRequest(items: $items, requestId: $requestId) {
            didCreate
        }
    }
`